import { render, staticRenderFns } from "./BarChartRest.vue?vue&type=template&id=3cbbe100&scoped=true&"
import script from "./BarChartRest.vue?vue&type=script&lang=js&"
export * from "./BarChartRest.vue?vue&type=script&lang=js&"
import style0 from "./BarChartRest.vue?vue&type=style&index=0&id=3cbbe100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbbe100",
  null
  
)

export default component.exports